var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBaselinePlace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 2.41675C9.82375 2.41675 6.04166 6.19883 6.04166 10.8751C6.04166 17.2188 14.5 26.5834 14.5 26.5834C14.5 26.5834 22.9583 17.2188 22.9583 10.8751C22.9583 6.19883 19.1762 2.41675 14.5 2.41675ZM14.5 13.8959C13.6988 13.8959 12.9305 13.5776 12.3639 13.0111C11.7974 12.4446 11.4792 11.6763 11.4792 10.8751C11.4792 10.0739 11.7974 9.30555 12.3639 8.73903C12.9305 8.17251 13.6988 7.85425 14.5 7.85425C15.3012 7.85425 16.0695 8.17251 16.636 8.73903C17.2026 9.30555 17.5208 10.0739 17.5208 10.8751C17.5208 11.6763 17.2026 12.4446 16.636 13.0111C16.0695 13.5776 15.3012 13.8959 14.5 13.8959Z",
    fill: "#F9F9F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBaselinePlace);
export default __webpack_public_path__ + "static/media/ic_baseline-place.6147a9bfff6ad5e1d9cd96605fe9876f.svg";
export { ForwardRef as ReactComponent };